import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { DomaineNouveauSansDossier } from '../models/dossiers/domaineNouveauSansDossier'

const resource = 'DomaineNouveauSansDossier'

export default class DomainesNouveauSansDossierResource {
  public async paginatedList(pagenumber?: number, pagesize?: number, actifonly?: boolean) : Promise<PaginatedList<DomaineNouveauSansDossier>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString());
    if (actifonly) params.append('ActifOnly', actifonly.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
